import { Component, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNReport } from 'src/app/models/cnreport';
import { PatientService } from 'src/app/services/patient.service';
import { ReportService } from 'src/app/services/report.service';

@ManageType('ReportTableComponent')
@Component({
  selector: 'app-report-table',
  templateUrl: './report-table.component.html',
  styleUrls: ['./report-table.component.scss']
})
export class ReportTableComponent implements OnInit {

  displayedColumns: string[] = ['report'];
  public datasource = new MatTableDataSource<CNReport>();
  @ViewChild('paginator', { static: true }) thePaginator;
  @Input() selectable = false;
  @Output() selected: EventEmitter<number[]> = new EventEmitter();

  private myLocation = 'default';
  private myShowPaginator = true;
  private selectedReports: number[] = [];
  private selectAllReport = false;

  constructor(public reportservice: ReportService) { }

  ngOnInit(): void {
  }

  @Input() set reports(theReports: CNReport[]) {
    this.selectedReports = [];
    this.datasource.data = theReports;
    if (this.selectAllReport) {
      theReports.forEach(aReport => {
        this.selectedReports.push(aReport.id);
      });
      this.selected.emit(this.selectedReports);
    }
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
  }

  @Input() set paginator(flag: boolean) {
    this.myShowPaginator = flag;
  }

  get paginator(): boolean {
    return this.myShowPaginator;
  }

  @Input() set selectall(flag: boolean) {
    this.selectAllReport = flag;
    this.selectedReports = [];
    if (flag) {
      this.datasource.data.forEach(aReport => {
        this.selectedReports.push(aReport.id);
      });
      this.selected.emit(this.selectedReports);
    }
  }

  toggle(itemid: number, checked: boolean) {
    if (checked) {
      if (this.selectedReports.indexOf(itemid) === -1) {
        this.selectedReports.push(itemid);
      }
    } else {
      if (this.selectedReports.indexOf(itemid) !== -1) {
        this.selectedReports.splice(this.selectedReports.indexOf(itemid), 1);
      }
    }
    this.selected.emit(this.selectedReports);
  }

  isChecked(itemid: number): boolean {
    return this.selectedReports.indexOf(itemid) === -1 ? false : true;
  }

  clear(): void {
    console.log('contact cleared');
    this.datasource.data = [];
    if (this.myShowPaginator) {
      this.thePaginator.pageIndex = 0;
    }
  }

  changePage(event: PageEvent): void {
    this.reportservice.dataStart = event.pageIndex * event.pageSize;
    this.reportservice.dataLimit = event.pageSize;
    this.reportservice.load();
  }
}
